async function ensureCostiesBlockedOnline() {
  if (
    !window.ShopSanteCustomer ||
    !window.ShopSanteCustomer.isLoggedIn ||
    !window.ShopSanteCustomer.isCosties
  ) {
    return Promise.resolve();
  }

  if (window.__costiesBlockOnlineSet === true) {
    return Promise.resolve();
  }

  if (window.__costiesBlockOnlinePromise) return window.__costiesBlockOnlinePromise;

  window.__costiesBlockOnlinePromise = fetch((window.Shopify?.routes?.root || "/") + "cart.js", {
    credentials: 'same-origin',
    headers: { 'Accept': 'application/json' },
    cache: 'no-store'
  })
    .then(response => {
      if (!response.ok) throw new Error(`Unable to read cart (${response.status})`);
      return response.json();
    })
    .then(cart => {
      if (cart?.attributes?.costies_block_online === 'true') {
        window.__costiesBlockOnlineSet = true;
        return null;
      }

      const cartFetch = window.StockPilotB2BNativeFetch || fetch;
      const mutation = () => cartFetch((window.Shopify?.routes?.root || "/") + "cart/update.js", {
        method: 'POST',
        credentials: 'same-origin',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json'
        },
        body: JSON.stringify({
          attributes: {
            costies_block_online: 'true'
          }
        })
      });
      const queue = window.StockPilotB2BCartMutationQueue;
      return queue?.enqueue ? queue.enqueue(mutation) : mutation();
    })
    .then(response => {
      if (response && !response.ok) {
        const error = new Error(`Unable to set cart attribute (${response.status})`);
        error.status = response.status;
        throw error;
      }
      window.__costiesBlockOnlineSet = true;
    })
    .catch(e => {
      window.__costiesBlockOnlineSet = false;
      console.error('Unable to set costies_block_online cart attribute', e);
    })
    .finally(() => {
      window.__costiesBlockOnlinePromise = null;
    });

  return window.__costiesBlockOnlinePromise;
}

function openCartDrawerOptimistic() {
  const drawer = document.querySelector('[data-js-site-cart-sidebar]');
  if (drawer && typeof drawer.show === 'function') {
    drawer.show();
  }
}

function setCartDrawerRefreshing(isRefreshing) {
  const drawer = document.querySelector('[data-js-site-cart-sidebar]');
  if (!drawer) return;
  drawer.classList.toggle('is-cart-refreshing', Boolean(isRefreshing));
  if (isRefreshing) drawer.setAttribute('aria-busy', 'true');
  else drawer.removeAttribute('aria-busy');
}

function refreshCartRecommendationsDelayed() {
  clearTimeout(window.__cartRecommendationsTimer);

  window.__cartRecommendationsTimer = setTimeout(() => {
    const recommendations = document.querySelector('cart-recommendations');

    if (!recommendations || typeof recommendations.generateRecommendations !== 'function') {
      return;
    }

    recommendations.innerHTML = '';
    recommendations.dataset.loaded = 'false';
    recommendations.generateRecommendations();
  }, 1200);
}

function applyHelperCartHTML(text, options = {}) {
  const sectionInnerHTML = new DOMParser().parseFromString(text, 'text/html');
  const newCartForm = sectionInnerHTML.getElementById('AjaxCartForm');
  const newCartSubtotal = sectionInnerHTML.getElementById('AjaxCartSubtotal');

  if (!newCartForm || !newCartSubtotal) {
    throw new Error('Unable to refresh helper cart section');
  }

  const cartItems = document.getElementById('AjaxCartForm');
  const cartSubtotal = document.getElementById('AjaxCartSubtotal');

  if (!cartItems || !cartSubtotal) {
    throw new Error('Cart form or subtotal not found');
  }

  cartItems.innerHTML = newCartForm.innerHTML;
  cartItems.ajaxifyCartItems();

  document.querySelectorAll('[data-header-cart-count]').forEach(elm => {
    const count = cartItems.querySelector('[data-cart-count]');
    if (count) elm.textContent = count.textContent;
  });

  document.querySelectorAll('[data-header-cart-total]').forEach(elm => {
    const total = cartItems.querySelector('[data-cart-total]');
    if (total) elm.textContent = total.textContent;
  });

  cartSubtotal.innerHTML = newCartSubtotal.innerHTML;
  setCartDrawerRefreshing(false);
  if (options.openDrawer !== false) openCartDrawerOptimistic();

  cartItems.dispatchEvent(new Event('cart-updated'));

  if (options.b2b !== true) {
    if (typeof InitSubmit === 'function') InitSubmit();
    if (typeof displayDonationMessageCartDrawer === 'function') displayDonationMessageCartDrawer();
    if (typeof checkShoppingInsurance === 'function') checkShoppingInsurance();
    if (typeof addCartNote === 'function') addCartNote();
  }
  if (typeof ShippingBar === 'function') ShippingBar();

  if (options.b2b !== true) refreshCartRecommendationsDelayed();
}

function refreshHelperCartNow(options = {}) {
  return ensureCostiesBlockedOnline()
    .then(() => {
      const sectionUrl = new URL(window.location.pathname, window.location.origin);
      sectionUrl.searchParams.set('section_id', 'helper-cart');
      return fetch(sectionUrl.toString(), {
        headers: { 'X-Requested-With': 'XMLHttpRequest' }
      });
    })
    .then(response => {
      if (!response.ok) throw new Error(`Impossible d'actualiser le panier (${response.status})`);
      return response.text();
    })
    .then(text => applyHelperCartHTML(text, options));
}

window.ShopSanteRefreshCart = refreshHelperCartNow;
window.ShopSanteApplyHelperCartHTML = applyHelperCartHTML;

if (typeof CartForm !== 'function') {
  class CartForm extends HTMLElement {
    constructor() {
      super();
      this.ajaxifyCartItems();

      if (window.ShopSanteCustomer?.isLoggedIn && window.ShopSanteCustomer?.isCosties) {
        ensureCostiesBlockedOnline();
      }

      this.handleClearCartClick = this.handleClearCartClick.bind(this);
    }

    connectedCallback() {
      document.addEventListener('click', this.handleClearCartClick);
    }

    disconnectedCallback() {
      document.removeEventListener('click', this.handleClearCartClick);
    }

    handleClearCartClick(e) {
      const clearCartLink = e.target.closest('[data-action="clear-cart"]');

      if (clearCartLink) {
        e.preventDefault();
        this.clearCart();
      }
    }

    ajaxifyCartItems() {
      this.form = this.querySelector('form');

      this.querySelectorAll('[data-js-cart-item]').forEach(item => {
        const remove = item.querySelector('.remove');

        if (remove && remove.dataset.ajaxified !== 'true') {
          remove.dataset.ajaxified = 'true';
          remove.dataset.href = remove.getAttribute('href');
          remove.setAttribute('href', '');

          remove.addEventListener('click', (e) => {
            e.preventDefault();
            this.updateCartQty(item, 0);
          });
        }

        const qty = item.querySelector('.qty');

        if (qty && qty.dataset.ajaxified !== 'true') {
          qty.dataset.ajaxified = 'true';

          const handleQtyInput = debounce(e => {
            e.preventDefault();
            e.target.blur();
            this.updateCartQty(item, parseInt(qty.value));
          }, 300);

          qty.addEventListener('input', e => {
            // Quantity buttons already schedule one immediate cart update.
            // Only retain this path for a real manual edit.
            if (!e.isTrusted && qty.closest('cart-product-quantity')) return;
            handleQtyInput(e);
          });

          qty.addEventListener('click', (e) => {
            e.target.select();
          });
        }
      });
    }

    clearCart() {
      this.form.classList.add('processing');

      fetch(KROWN.settings.routes.cart_clear_url, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' }
      })
        .then(response => {
          if (response.ok) {
            window.__costiesBlockOnlineSet = false;
            return ensureCostiesBlockedOnline().then(() => response);
          } else {
            throw new Error('Erreur lors de la suppression du panier');
          }
        })
        .then(() => {
          return refreshHelperCartNow();
        })
        .finally(() => {
          this.form.classList.remove('processing');
        })
        .catch(error => {
          console.error(error);

          let alert = document.createElement('span');
          alert.classList.add('alert', 'alert--error');
          alert.textContent = KROWN.settings.locales.cart_general_error;
          this.form.prepend(alert);
        });
    }

    updateCartQty(item, newQty) {
      this.form.classList.add('processing');

      if (this.querySelector('.alert')) {
        this.querySelector('.alert').remove();
      }

      const requestedQty = Number.isFinite(newQty) ? newQty : 0;
      const minimumQty = parseInt(item?.dataset?.stockPilotMinQty || '0', 10);
      newQty = requestedQty;

      if (Number.isFinite(minimumQty) && minimumQty > 0 && requestedQty < minimumQty) {
        newQty = minimumQty;
        const qty = item.querySelector('.qty');
        if (qty) qty.value = String(minimumQty);
      }

      const body = JSON.stringify({
        id: item.dataset.id,
        quantity: newQty,
        sections: 'helper-cart',
        sections_url: window.location.pathname
      });

      let releaseInventory;
      let mutationStarted = false;
      const findCartItem = () => Array.from(document.getElementById('AjaxCartForm')?.querySelectorAll('[data-js-cart-item]') || [])
        .find(cartItem => cartItem.dataset.id === item.dataset.id);
      window.ShopSanteInventory.lock()
        .then(release => { releaseInventory = release; return window.ShopSanteInventory.validateChange(item.dataset.id, newQty); })
        .then(() => ensureCostiesBlockedOnline())
        .then(() => {
          mutationStarted = true;
          return fetch(`${KROWN.settings.routes.cart_change_url.replace(/\.js$/, '')}.js`, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
            body
          });
        })
        .then(response => {
          if (response.ok) {
            return response.json();
          } else {
            const error = new Error(response.status === 422
              ? (document.documentElement.lang?.startsWith('fr')
                ? 'Cette quantité n’est plus disponible. Vérifiez le stock et réessayez.'
                : 'This quantity is no longer available. Check stock and try again.')
              : KROWN.settings.locales.cart_general_error);
            error.userMessage = true;
            throw error;
          }
        })
        .then(cart => {
          const helperCartHTML = cart?.sections?.['helper-cart'];
          if (helperCartHTML) {
            applyHelperCartHTML(helperCartHTML);
            return;
          }

          return refreshHelperCartNow();
        })
        .then(() => {
          const updatedItem = findCartItem();
          if (newQty != 0 && updatedItem && newQty > parseInt(updatedItem.dataset.qty)) {
            let alert = document.createElement('span');
            alert.classList.add('alert', 'alert--error');
            alert.innerHTML = KROWN.settings.locales.cart_add_error.replace('{{ title }}', item.dataset.title);
            this.form.prepend(alert);
          }
        })
        .catch(async e => {
          console.error('Unable to update cart quantity', e);

          if (mutationStarted) {
            try {
              await refreshHelperCartNow({ openDrawer: false });
              const updatedItem = findCartItem();
              if (newQty === 0 ? !updatedItem : Number(updatedItem?.dataset.qty) === newQty) return;
            } catch (refreshError) {
              console.error('Unable to reconcile cart quantity', refreshError);
            }
          }

          let alert = document.createElement('span');
          alert.classList.add('alert', 'alert--error');
          alert.textContent = e.userMessage ? e.message : KROWN.settings.locales.cart_general_error;
          const currentItem = findCartItem() || item;
          const input = currentItem.querySelector('.qty');
          if (input) input.value = currentItem.dataset.qty;
          alert.setAttribute('role', 'alert');
          alert.style.gridColumn = '1 / -1';
          currentItem.append(alert);
        })
        .finally(() => {
          releaseInventory?.();
          this.form.classList.remove('processing');
        });
    }
  }

  if (typeof customElements.get('cart-form') == 'undefined') {
    customElements.define('cart-form', CartForm);
  }
}

if (typeof CartProductQuantity !== 'function') {
  class CartProductQuantity extends HTMLElement {
    constructor() {
      super();
      this.cartUpdateTimer = null;
      this.querySelector('.qty-minus').addEventListener('click', this.changeCartInput.bind(this));
      this.querySelector('.qty-plus')?.addEventListener('click', this.changeCartInput.bind(this));
    }

    changeCartInput() {
      clearTimeout(this.cartUpdateTimer);
      this.cartUpdateTimer = setTimeout(() => {
        const quantity = this.querySelector('.qty').value;
        this.setAttribute('data-quantity', quantity);
        document.getElementById('AjaxCartForm')?.updateCartQty(
          this.closest('[data-js-cart-item]'),
          parseInt(quantity)
        );
      }, 300);
    }
  }

  if (typeof customElements.get('cart-product-quantity') == 'undefined') {
    customElements.define('cart-product-quantity', CartProductQuantity);
  }
}

if (typeof CartDetails !== 'function') {
  class CartDetails extends HTMLElement {
    constructor() {
      super();
      this.footer = document.querySelector('.shopify-section .footer');

      if (this.footer) {
        this.init();
      }
    }

    init() {
      this.handleScroll = this.handleScroll.bind(this);
      this.handleScroll();
      window.addEventListener('scroll', this.handleScroll);
      window.addEventListener('resize', this.handleScroll);
    }

    handleScroll() {
      if (!this.footer) return;

      const footerRect = this.footer.getBoundingClientRect();
      const footerTop = footerRect.top;
      const viewportMiddle = window.innerHeight / 2;

      if (footerTop <= viewportMiddle) {
        this.classList.add('invisible');
      } else {
        this.classList.remove('invisible');
      }
    }

    disconnectedCallback() {
      window.removeEventListener('scroll', this.handleScroll);
      window.removeEventListener('resize', this.handleScroll);
    }
  }

  if (typeof customElements.get('cart-details') == 'undefined') {
    customElements.define('cart-details', CartDetails);
  }
}

if (!window.refreshCart) {
  window.refreshCart = () => {
    openCartDrawerOptimistic();
    setCartDrawerRefreshing(true);

    clearTimeout(window.__refreshCartTimer);

    window.__refreshCartTimer = setTimeout(() => {
      if (window.__refreshCartPromise) {
        window.__refreshCartQueued = true;
        return;
      }

      window.__refreshCartPromise = refreshHelperCartNow()
        .catch(e => {
          console.error(e);
          setCartDrawerRefreshing(false);
        })
        .finally(() => {
          window.__refreshCartPromise = null;

          if (window.__refreshCartQueued) {
            window.__refreshCartQueued = false;
            window.refreshCart();
          }
        });
    }, 250);
  };
}
